import { render, staticRenderFns } from "./AddOneToCart.vue?vue&type=template&id=5e084ff4&scoped=true&"
import script from "./AddOneToCart.vue?vue&type=script&lang=ts&"
export * from "./AddOneToCart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e084ff4",
  null
  
)

export default component.exports